export default "__VITE_PUBLIC_ASSET__405878be__"